// extracted by mini-css-extract-plugin
export default {"MyProfile":"MyProfile_MyProfile__FJR6g","profileUpload":"MyProfile_profileUpload__CH2Cd","imgWrp":"MyProfile_imgWrp__+vRxw"};